import Model from './Model';

export default class Persiana extends Model {
    boot() {
        super.boot();

        this.modelName = 'Persianas';
        this.config.customRoutes = [
            {
                name: 'update',
                type: 'patch',
                url: 'persianas/{id}/'
            }
        ]
    }

    update = (id, params) => {
        return this.withParams(params).route('update', { id });
    };

}
